import pixelmatch from 'pixelmatch';

import { convert } from 'js/shared/lib/SVGConvert';

async function getImagePixelsFromBlob(blob: Blob) {
  // Create a canvas and print the blob onto it and get the ImageData.data from it
  const cavnas = document.createElement('canvas');
  const ctx = cavnas.getContext('2d');

  if (!ctx) {
    throw new Error('Could not create canvas context');
  }

  const img = new Image();
  const url = URL.createObjectURL(blob);
  img.src = url;
  await img.decode();
  cavnas.width = img.width;
  cavnas.height = img.height;
  ctx.drawImage(img, 0, 0);
  const imageData = ctx.getImageData(0, 0, cavnas.width, cavnas.height);
  URL.revokeObjectURL(url);
  return { pixels: imageData.data, width: imageData.width, height: imageData.height };
}

export async function compareSvgToConverted(original: Blob) {
  const {
    pixels: originalPixels,
    width: originalWidth,
    height: originalHeight
  } = await getImagePixelsFromBlob(original);
  const convertedSvgText = convert(await original.text());
  const convertedBlob = new Blob([convertedSvgText], { type: 'image/svg+xml' });
  const { pixels: convertedPixels } = await getImagePixelsFromBlob(convertedBlob);

  const result = pixelmatch(originalPixels, convertedPixels, undefined, originalWidth, originalHeight);

  return result;
}

export const PIXEL_DIFFERENCE_ALLOWANCE = 10;
